// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import { toast } from 'react-toastify';
import {
    FaBug,
    FaCheck,
    FaExclamationCircle,
    FaExclamationTriangle,
    FaInfo,
} from 'react-icons/fa';

export const displayIcon = (type: string) => {
    switch (type) {
        case 'success':
            return <FaCheck />;
        case 'info':
            return <FaInfo />;
        case 'error':
            return <FaExclamationCircle />;
        case 'warning':
            return <FaExclamationTriangle />;
        default:
            return <FaBug />;
    }
};

interface ToastProps {
    type: string;
    message: string;
}
const ToastMessage: React.FC<ToastProps> = ({ type, message }) =>
    toast[type](
        <div style={{ display: 'flex' }}>
            <div
                dangerouslySetInnerHTML={{ __html: message }}
                style={{ flexGrow: 1, fontSize: 15, padding: '8px 12px' }}
            />
        </div>,
    );

ToastMessage.dismiss = toast.dismiss;

export default ToastMessage;
